import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';

import './main-menu';
import './links';

document.addEventListener('DOMContentLoaded', function () {
  const associationSearchPage = document.querySelector('.associationsearchpage');
  if (!associationSearchPage) return;
  associationSearchPage.querySelector('.search-input')?.focus();
})